import './App.css';
//images
import IEBC from './Components/Images/IEBC.png';
import COA from './Components/Images/COA.png';

//components
import Nav from './Components/Nav'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>KENYA ELECTRONIC VOTING INFORMATION NETWORK</h1>
        <div className='logos'>
          <img src={IEBC} alt="IEBC"/>
          <img src={COA} alt="IEBC"/>
          <i className="fa fa-user-circle-o"></i>
        </div>
      </header>
      <Nav/>
    </div>
  );
}

export default App;
